import SecureIcon from "assets/svg/secure.svg";
import FlagIcon from "assets/svg/flag.svg";

export const listItems = [
  {
    id: 1,
    icon: <SecureIcon />,
    title: "Güvenlik Önerileri",
    content: "Gayrimenkulu görmeden, hiçbir sebeple kapora ve benzeri ödeme gerçekleştirmeyin.",
    ga4EventLabel: "security-advice",
  },
  {
    id: 2,
    icon: <FlagIcon />,
    title: "Hatalı İlan Bildir",
    content: "Hatalı bilgi içeren veya iletişim sorunu yaşadığınız ilanları bildirin.",
    ga4EventLabel: "report-item-form",
  },
];
